import React from "react";
var __jsx = React.createElement;
import { createContext, useContext, useState, useMemo } from "react";
const OffersContext = /*#__PURE__*/createContext(undefined);
export function OffersProvider(_ref) {
  let {
    children
  } = _ref;
  const {
    0: availableOffers,
    1: setAvailableOffers
  } = useState(undefined);
  const value = useMemo(() => ({
    availableOffers,
    setAvailableOffers
  }), [availableOffers]);
  return __jsx(OffersContext.Provider, {
    value: value
  }, children);
}
export function useOffers() {
  const context = useContext(OffersContext);
  if (context === undefined) {
    throw new Error("useOffers must be used within an OffersProvider");
  }
  return context;
}